import React from 'react';
import SatInput from '@components/common/satUI/SatInput';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import { isEmptyString, replaceDateLetters } from '@common/utils';
import SatButton from './SatButton';

const SatDateInput = ({
  title,
  placeholder,
  value,
  splitter,
  dateLength = 8,
  isErrorVisible,
  errorMessage,
  onChange,
}) => {
  const rawValue = value.replace(/[^0-9]/g, '');

  const handleChange = value => {
    const rawValue = value.replace(/[^0-9]/g, '');
    const dateFormat =
      dateLength === 6
        ? `yy${splitter}mm${splitter}`
        : `yyyy${splitter}MM${splitter}dd`;

    const dateValue = replaceDateLetters(rawValue, dateFormat);

    if (typeof onChange === 'function') onChange(dateValue);
  };

  return (
    <>
      <SatInput
        useDate
        type="number"
        splitter={splitter}
        maxLength={dateLength}
        focusLabel={title}
        placeholder={placeholder}
        suffix={
          !isEmptyString(value)
            ? () => (
                <SatButton
                  styleClass="ico ico-del"
                  onClick={() => onChange('')}
                />
              )
            : null
        }
        value={rawValue}
        onChange={handleChange}
      />

      <SatValidationErrMsg
        type="error"
        visible={isErrorVisible}
        message={errorMessage}
      />
    </>
  );
};

export default SatDateInput;
